import { awaitingAcceptance, usePlans } from "../../api/routing";
import { SubTabs } from "../../components/ui";

/** Planner | Plans | Emergency overrides | Schedule: the screens of Routing, each its own address. The count on Plans is the plans still waiting to be accepted,
 * because a saved proposal nobody accepted raises no inspections. */
export default function RoutingTabs() {
  const plans = usePlans(false);
  const waiting = plans.data ? awaitingAcceptance(plans.data.rows) : 0;
  return (
    <SubTabs
      label="Routing"
      tabs={[
        { to: "/routing", label: "Planner" },
        { to: "/routing/plans", label: "Plans", end: false, count: waiting > 0 ? waiting : undefined, countTone: "warn" },
        { to: "/routing/overrides", label: "Emergency overrides" },
        { to: "/schedule", label: "Schedule" },
      ]}
    />
  );
}
